import { render, staticRenderFns } from "./BatchReceipt.vue?vue&type=template&id=1970f688&"
import script from "./BatchReceipt.vue?vue&type=script&lang=js&"
export * from "./BatchReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports